// Animation utilities for Shopping List component

// Animation variants for framer-motion
export const animations = {
  // List item animations
  listItem: {
    initial: { opacity: 0, x: -20 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: 20 },
    transition: { duration: 0.2 }
  },
  
  // Card animations
  card: {
    initial: { opacity: 0, y: 10 },
    animate: { opacity: 1, y: 0 },
    hover: { y: -2, boxShadow: "0 4px 12px rgba(0,0,0,0.1)" },
    tap: { scale: 0.98 },
    transition: { duration: 0.2 }
  },
  
  // Success animation
  success: {
    initial: { scale: 0, opacity: 0 },
    animate: { 
      scale: [0, 1.2, 1], 
      opacity: [0, 1, 1],
      transition: { duration: 0.4 }
    }
  },
  
  // Fade in/out
  fade: {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    transition: { duration: 0.15 }
  },
  
  // Collapse animation for aisles
  collapse: {
    initial: { height: 0, opacity: 0 },
    animate: { height: "auto", opacity: 1 },
    exit: { height: 0, opacity: 0 },
    transition: { duration: 0.2 }
  },
  
  // Stagger children animations
  staggerContainer: {
    animate: {
      transition: {
        staggerChildren: 0.05,
        delayChildren: 0.1
      }
    }
  },
  
  // Button hover
  buttonHover: {
    hover: { scale: 1.05 },
    tap: { scale: 0.95 },
    transition: { type: "spring", stiffness: 400, damping: 17 }
  },
  
  // Skeleton loading animation
  skeleton: {
    animate: {
      backgroundPosition: ["200% 0", "-200% 0"],
      transition: {
        duration: 1.5,
        ease: "linear",
        repeat: Infinity
      }
    }
  }
};

// Transition presets
export const transitions = {
  spring: { type: "spring", stiffness: 300, damping: 25 },
  smooth: { duration: 0.3, ease: "easeInOut" },
  quick: { duration: 0.15, ease: "easeOut" }
};

// Layout animation configuration
export const layoutAnimation = {
  layout: true,
  layoutScroll: true,
  transition: transitions.spring
};